import React, { Fragment, useState } from 'react';
import { Container, Grid, Table, Card, Button, Page, Dimmer } from "tabler-react";
import { useFetch } from '../../lib/useFetch';
import PaginationBar from '../../components/pagination';
import SearchInput from '../../components/searchInput';

const Products = ({ openMainModal }) => {
  const [page, setPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');
  const [reload, toggleReload] = useState(false)

  const onSearch = (term) => {
    setSearchQuery(term);
    setPage(1);
  };

  const searchParam = searchQuery ? `&search=${encodeURIComponent(searchQuery)}` : '';
  const { data, loading, totalCount } = useFetch(`products?page=${page}${searchParam}`, reload);

  return (
    <Fragment>
      <Container>
        <Page.Header>
          <Page.Title>Products</Page.Title>
        </Page.Header>
        <Grid>
          <Grid.Row>
            <Card>
              <Dimmer active={loading} loader={loading}>
                <Card.Header>
                  <Card.Options>
                    <SearchInput value={searchQuery} onSubmit={onSearch} />
                    <Button
                      className="ml-2"
                      icon="plus"
                      color="primary"
                      size="md"
                      onClick={() => openMainModal('product-create', null, () => toggleReload(r => !r))}
                    >
                      Create Product
                    </Button>
                  </Card.Options>
                </Card.Header>

                {!loading && (!data || data.length < 1) ? (
                  <div className="alert alert-primary m-0">
                    No Products to show!
                  </div>
                ) : (
                  <div className="table-responsive-wrapper">
                    <Table
                      hasOutline
                      striped
                      className="table card-table table-vcenter"
                    >
                      <Table.Header>
                        {['image', 'name', 'description', 'url', 'price'].map((head, i) => (
                          <Table.ColHeader key={`tableHeader-${i}`}>
                            {head}
                          </Table.ColHeader>
                        ))}
                        <Table.ColHeader>Actions</Table.ColHeader>
                      </Table.Header>
                      <Table.Body>
                        {data && data.map(({ name, image, description, productUrl, price, _id }, i) => (
                          <Table.Row key={i}>
                            <Table.Col>
                              <img width="50" height="50" src={image} alt={name || "Product"} />
                            </Table.Col>

                            <Table.Col>
                              {name}
                            </Table.Col>

                            <Table.Col>
                              {description}
                            </Table.Col>

                        <Table.Col>
                          {productUrl
                            ? <a href={productUrl} target="_blank" rel="noreferrer"
                                 style={{ textDecoration: 'underline', color: '#467fcf' }}
                                 title={productUrl}>
                                {productUrl.length > 40 ? `${productUrl.slice(0, 40)}…` : productUrl}
                              </a>
                            : <span className="text-muted">—</span>}
                        </Table.Col>

                            <Table.Col>
                              {price}
                            </Table.Col>

                            <Table.Col>
                              <div className="actions-wrap">
                                <Button
                                  outline
                                  color="secondary"
                                  size="sm"
                                  onClick={() => openMainModal('product-view', _id)}
                                >
                                  View
                                </Button>

                                <Button
                                  outline
                                  color="secondary"
                                  className="ml-2 mr-2"
                                  size="sm"
                                  onClick={() => openMainModal('product-edit', _id, () => toggleReload(r => !r))}
                                >
                                  Edit
                                </Button>

                                <Button
                                  outline
                                  color="danger"
                                  size="sm"
                                  onClick={() => openMainModal('products--delete', _id, () => toggleReload(r => !r))}
                                >
                                  Delete
                                </Button>
                              </div>
                            </Table.Col>
                          </Table.Row>
                        ))}
                      </Table.Body>
                    </Table>
                  </div>
                )}

                {data && data.length > 0 && (
                  <PaginationBar
                    page={page}
                    totalCount={totalCount}
                    setPage={setPage}
                  />
                )}
              </Dimmer>
            </Card>
          </Grid.Row>
        </Grid>
      </Container>
    </Fragment>
  );
}

export default Products;